import React from 'react';
import { Row, Col } from 'antd';
import { Paragraph, Title } from '@/components/Typography';

export function Header(): JSX.Element {
	return (
		<Row align="middle">
			<Col>
				<Title level={4}>Evaluation</Title>
			</Col>
			<Col xs={24}>
				<Paragraph>
					Computer vision identified the positions of each task, review and add the required information
				</Paragraph>
			</Col>
		</Row>
	);
}
